import { z } from 'zod';

export enum VerificationTypeEnum {
  KYC = 'kyc',
  POA = 'poa',
  DOCS = 'docs',
}

export const VerificationTypeSchema = z.nativeEnum(VerificationTypeEnum);

export const VerificationStateSchema = z.enum([
  'not-submitted',
  'pending',
  'incomplete',
  'approved',
  'rejected',
  'resubmission-requested',
]);

export const VerificationErrorSchema = z.object({
  message: z.string().nullable(),
  code: z.string().nullable(),
});

export const UserVerificationDtoSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  type: VerificationTypeSchema,
  state: VerificationStateSchema,
  provider: z.string().nullable(),
  externalUserId: z.string().nullable(),
  providerDetails: z.unknown().nullable(),
  error: VerificationErrorSchema.nullable(),
  reviewerComment: z.string().nullable(),
  reviewedBy: z.string().nullable(),
  reviewedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type VerificationType = VerificationTypeEnum;
export type VerificationState = z.infer<typeof VerificationStateSchema>;
export type VerificationError = z.infer<typeof VerificationErrorSchema>;
export type UserVerificationDto = z.infer<typeof UserVerificationDtoSchema>;
